function wrapContentTables() {
    const tables = document.querySelectorAll('table');

    const scrollTextEl = document.createElement('div');
    scrollTextEl.setAttribute('class', 'table__scroll-text-container');

    if (tables) {
        tables.forEach((table) => {
            const tableClasses = [...table.classList];
            tableClasses.push('table');
            table.setAttribute('class', tableClasses.join(' '));

            const tableWrapperEl = document.createElement('div');
            tableWrapperEl.setAttribute('class', 'table__wrapper');

            const tableContEl = document.createElement('div');
            tableContEl.setAttribute('class', 'table__container');

            table.parentNode.insertBefore(tableContEl, table);
            tableContEl.appendChild(table);

            tableContEl.parentNode.insertBefore(tableWrapperEl, tableContEl);

            tableWrapperEl.appendChild(tableContEl);
            tableWrapperEl.appendChild(scrollTextEl);
        });
    }
}

wrapContentTables();
